export enum EProjectTypes {
  L2 = "L2",
  DCFC = "DCFC",
  MICROMOBILITY = "MICROMOBILITY",
  MHD = "MHD",
  MIXED = "MIXED",
  ALL = "ALL",
}

export const PROJECT_TYPE_NAME_BY_ENUM = {
  [EProjectTypes.L2]: "Level 2",
  [EProjectTypes.DCFC]: "DCFC",
  [EProjectTypes.MICROMOBILITY]: "Micromobility",
  [EProjectTypes.MHD]: "Medium- Heavy-Duty",
  [EProjectTypes.MIXED]: "Mixed",
  [EProjectTypes.ALL]: "Mixed",
};

export enum EProjectAccessibility {
  PUBLICLY_ACCESSIBLE = "publicly_available",
  PRIVATELY_ACCESSIBLE = "privately_accessible",
  MIXED_ACCESSIBILITY = "mixed_accessibility",
  NOT_SURE_ACCESSIBILITY = "not_sure_accessibility",
}

export const PROJECT_ACCESSIBILITY_NAME_BY_ENUM = {
  [EProjectAccessibility.PUBLICLY_ACCESSIBLE]: "Publicly Accessible",
  [EProjectAccessibility.PRIVATELY_ACCESSIBLE]: "Privately Accessible",
  [EProjectAccessibility.MIXED_ACCESSIBILITY]: "Shared Charging Hub",
  [EProjectAccessibility.NOT_SURE_ACCESSIBILITY]: "Not Sure on Accessibility",
};

export const LIGHT_DUTY_PROJECT_TYPES = [
  EProjectTypes.L2,
  EProjectTypes.DCFC,
  EProjectTypes.MICROMOBILITY,
];

export enum EIncentiveName {
  BASELINE = "baseline_dollars_per_unit", // not really an incentive
  DAC = "dac", // not really an incentive
  PUBLICLY_ACCESSIBLE = "publicly_available", // not really an incentive
  PRIVATELY_ACCESSIBLE = "privately_available", // not really an incentive, set as !publicly_available
  SPEED_BONUS = "speed_bonus_dollars_per_unit",
  LARGE_PROJECT_BONUS = "large_project_bonus_dollars_per_unit",
  LOAD_MANGEMENT_BONUS = "load_management_bonus_dollars_per_unit",
  INTERCONNECTION_BONUS = "interconnection_bonus_dollars_per_unit",
  FUTURE_PROOFING_BONUS = "future_proofing_bonus_percent",
  NON_PROPRIETARY_PLUGS_BONUS = "non_proprietary_plugs_bonus_percent",
}

// app/models/contact.rb
// db/migrate/20250205212153_add_role_to_contact.rb
export enum EContactRole {
  CHARGER_OWNER = "charger_owner",
  REAL_ESTATE = "real_estate",
  DEVELOPER = "developer",
  FLEET_OWNER = "fleet_owner",
}

export const ROLE_OPTIONS = [
  {
    label: "Charger Owner / Operator",
    value: EContactRole.CHARGER_OWNER,
  },
  {
    label: "Real Estate Developer / Property Owner",
    value: EContactRole.REAL_ESTATE,
  },
  {
    label: "Developer or General Contractor",
    value: EContactRole.DEVELOPER,
  },
  {
    label: "Fleet Owner / Operator",
    value: EContactRole.FLEET_OWNER,
  },
];
